import {
    SET_LOADING_FORGOT
} from "../constant/forgot-reset";

export const setLoadingForgot = value => ({
    type: SET_LOADING_FORGOT,
    payload: value 
});